// AdminView.tsx
import React from 'react';
import { Stack, Text } from '@fluentui/react';
import { Button } from '@fluentui/react-components';
import { useNavigate } from 'react-router-dom';
import UploadCard from '../UploadCard/UploadCard';
import { postStudentsSubjectList } from 'src/endpoints/postStudentsSubjectList';
import { postProfessorsSchedule } from 'src/endpoints/postProfessorsSchedule';
import { postActiveEmployees } from 'src/endpoints/postActiveEmployees';

const uploadEmployeesSchedule = async (file: File) => {
  try {
    return postProfessorsSchedule(file);
  } catch (error) {
    console.error('Error uploading employees schedule:', error);
    alert(
      'Error al subir el archivo de horarios. Por favor, inténtalo de nuevo.'
    );
  }
};

const uploadSubjectsList = async (file: File, plan?: string) => {
  if (!plan) {
    alert('Por favor selecciona un plan.');
    return;
  }
  try {
    return postStudentsSubjectList(file, plan);
  } catch (error) {
    console.error('Error uploading subjects list:', error);
    alert(
      'Error al subir el archivo de materias. Por favor, inténtalo de nuevo.'
    );
  }
};

const uploadEmployeesDb = async (file: File) => {
  try {
    return postActiveEmployees(file);
  } catch (error) {
    console.error('Error uploading employees database:', error);
    alert(
      'Error al subir el archivo de empleados. Por favor, inténtalo de nuevo.'
    );
  }
};

const volverButtonStyle = {
  backgroundColor: '#f5f5f5',
  border: '1px solid #ccc',
};

const uploadDescriptions = {
  employeesDb: `ESTE ES EL PASO INICIAL. Reiniciará la base de datos completa.
  Al enviar el archivo, se actualizarán cuáles son los empleados activos. Así mismo, para que se vean reflejados
  los cambios correctamente.`,
  employeesSchedule: `Al enviar el archivo, se actualizarán cuáles son las materias que tiene
  cada profesor. Así mismo, para que se vean reflejados los cambios
  correctamente, se tiene que subir la lista de empleados/profesores de
  nuevo.`,
  subjectsList: `Al enviar el archivo, se actualizarán cuáles son los alumnos que
  están inscritos en cada materia.`,
};

const stackTokens = { childrenGap: 20, padding: 20 };

const AdminView: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Stack tokens={stackTokens}>
      <Stack horizontal horizontalAlign="start">
        <Button
          appearance="secondary"
          size="large"
          style={volverButtonStyle}
          onClick={() => navigate('/dashboard')}
        >
          Volver
        </Button>
      </Stack>
      <Stack horizontalAlign="center" tokens={stackTokens}>
        <Text variant="xxLarge">Control de archivos</Text>
        <Text variant="mediumPlus" style={{ textAlign: 'start' }}>
          Los archivos que se vayan a subir reemplazarán lo que contiene la base
          de datos. Se tiene que realizar en el siguiente orden:
          <ol>
            <li>Subir archivo de profesores (Excel)</li>
            <li>Subir archivo horarios de cada profesor (Excel)</li>
            <li>
              Subir archivo de materias con lista de alumnos (TXT) y seleccionar
              el plan (420, 430 o 440)
            </li>
          </ol>
        </Text>
        <UploadCard
          title="1.- Subir archivo de profesores activos (Excel)"
          description={uploadDescriptions.employeesDb}
          allowedExtensions={['xlsx']}
          uploadHandler={uploadEmployeesDb}
        />
        <UploadCard
          title="2.- Subir archivo horarios de cada profesor (Excel)"
          description={uploadDescriptions.employeesSchedule}
          allowedExtensions={['xlsx']}
          uploadHandler={uploadEmployeesSchedule}
        />
        <UploadCard
          title="3.- (PASO FINAL) Subir archivo de materias con lista de alumnos (TXT)"
          description={uploadDescriptions.subjectsList}
          allowedExtensions={['txt']}
          plans={['420', '430', '440']}
          uploadHandler={uploadSubjectsList}
        />
      </Stack>
    </Stack>
  );
};

export default AdminView;
